var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    rx: 3,
    fill: "#8087D7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99857 3.10494C7.9029 3.05177 7.7977 3.01796 7.68896 3.00546C7.58022 2.99295 7.47009 3.00199 7.36484 3.03205C7.2596 3.06212 7.16131 3.11262 7.07559 3.18068C6.98986 3.24873 6.91839 3.33301 6.86524 3.42869L5.31816 6.21286L4.43274 5.32744C4.35587 5.24785 4.26391 5.18437 4.16224 5.14069C4.06057 5.09702 3.95122 5.07403 3.84057 5.07307C3.72993 5.07211 3.62019 5.09319 3.51778 5.13509C3.41536 5.17699 3.32232 5.23887 3.24408 5.31711C3.16583 5.39536 3.10396 5.4884 3.06206 5.59081C3.02015 5.69323 2.99907 5.80296 3.00003 5.91361C3.00099 6.02426 3.02398 6.13361 3.06766 6.23528C3.11133 6.33695 3.17481 6.4289 3.25441 6.50578L4.92107 8.17244C5.07857 8.33036 5.29107 8.41703 5.51024 8.41703L5.62566 8.40869C5.75339 8.39083 5.87523 8.34355 5.98158 8.2706C6.08794 8.19765 6.17591 8.101 6.23857 7.98828L8.32191 4.23828C8.3751 4.14263 8.40893 4.03745 8.42146 3.92873C8.434 3.82001 8.425 3.70988 8.39497 3.60464C8.36495 3.4994 8.31449 3.4011 8.24647 3.31537C8.17846 3.22963 8.09422 3.15812 7.99857 3.10494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.4f1d6f28fa086557c6cb982d1c09286a.svg";
export { ForwardRef as ReactComponent };